"use client"

import { useRef } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./TeamSection.css"

// Importación de imágenes - MANTENGO TUS RUTAS EXACTAS
import TelmetergyImg from "../assets/images/Telmetergy.png"
import ChecImg from "../assets/images/Chec.svg"
import CelciaImg from "../assets/images/Celcia.svg"
import EmsaImg from "../assets/images/Emsa.png"
import CensImg from "../assets/images/Cens.png"
import EnergiallaneraImg from "../assets/images/Energiallanera.png"
import MovilgoImg from "../assets/images/Movilgo.png"
import UlasalleImg from "../assets/images/logo-universidad-de-la-salle-removebg-preview.png"
import TinkinImg from "../assets/images/Tinkin.png"
import transitandoImg from "../assets/images/transitando.png"

const teamMembers = [
  { image: TelmetergyImg, alt: "Telmetergy", name: "Telmetergy" },
  { image: CelciaImg, alt: "Celcia", name: "Celcia" },
  { image: ChecImg, alt: "Chec", name: "Chec" },
  { image: EmsaImg, alt: "Emsa", name: "Emsa" },
  { image: CensImg, alt: "Cens", name: "Cens" },
  { image: EnergiallaneraImg, alt: "Enerca", name: "Enerca" },
  { image: MovilgoImg, alt: "Movilgo", name: "Movilgo" },
  { image: UlasalleImg, alt: "Universidad la Salle", name: "Universidad la Salle" },
  { image: TinkinImg, alt: "Tink In", name: "Tink In" },
  { image: transitandoImg, alt: "Transitando", name: "Transitando" },
]

const TeamSection = () => {
  const sliderRef = useRef(null)

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  }

  return (
    <section id="team" className="modern-team-section">
      {/* Animated Background Elements */}
      <div className="team-bg-animation">
        <div className="floating-shapes">
          {[...Array(12)].map((_, i) => (
            <div key={i} className={`shape shape-${i + 1}`} />
          ))}
        </div>
        <div className="gradient-orbs">
          <div className="orb orb-1" />
          <div className="orb orb-2" />
          <div className="orb orb-3" />
        </div>
      </div>

      <div className="container team-carousel-container">
        <div className="team-header">
          <div className="header-badge">
            <span>✨ Nuestros Aliados</span>
          </div>

          <h2 className="team-title">
            <span className="title-main">Nuestras Marcas Aliadas</span>

          </h2>

          <p className="team-subtitle">
            Estamos construyendo alianzas estratégicas que nos permiten
            ofrecer soluciones integrales y de alta calidad.
          </p>

          <div className="stats-row">
            <div className="stat-item">
              <div className="stat-icon">👥</div>
              <div className="stat-content">
                <span className="stat-number">20+</span>
                <span className="stat-label">Años de Experiencia</span>
              </div>
            </div>

            <div className="stat-item">
              <div className="stat-icon">⚡</div>
              <div className="stat-content">
                <span className="stat-number">100%</span>
                <span className="stat-label">Satisfacción</span>
              </div>
            </div>
          </div>
        </div>

        <Slider ref={sliderRef} {...settings} className="modern-carousel">
          {teamMembers.map((member, index) => (
            <div key={index} className="logo-slide">
              <div className="logo-card-modern">
                <div className="card-glow" />

                <img src={member.image || "/placeholder.svg"} alt={member.alt} className="logo-image-team" style={{ height: '120px' }} />

                <div className="card-overlay">
                  <span className="partner-name">{member.name}</span>
                </div>
                <div className="card-border" />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  )
}

export default TeamSection
